import {Skeleton} from '@dropbox/dig-components/skeleton';
import {Box, withShade} from '@dropbox/dig-foundations';
import {LabelGroup} from 'components/DSYS/LabelGroup';
import {LabelText} from 'components/gratitiude/LabelText';
import {t} from 'i18next';

import styles from './Gratitude.module.css';
import leaderboardStyles from './Leaderboard.module.css';

const MAX_PEOPLE = 16;

export const LeaderboardSkeleton = ({title}: {title: string}) => {
  return (
    <>
      <div className={styles.subtitle}>
        <LabelText>
          <span>{t(title)}</span>
        </LabelText>
        <span className={leaderboardStyles.count}>{'-'}</span>
      </div>
      <div className={leaderboardStyles.profileList}>
        {Array.from({length: MAX_PEOPLE}).map((_, index) => {
          return (
            <div className={leaderboardStyles.textContainer} key={index}>
              <Box
                paddingY="8"
                paddingX="12"
                borderRadius="Medium"
                {...withShade({
                  duration: 'Instant',
                  style: {marginLeft: -8, opacity: (10 - index * 2) / 8},
                })}
              >
                <LabelGroup
                  size="large"
                  withLeftAccessory={<Skeleton.Avatar />}
                  withText={<Skeleton.Text style={{width: 100}} />}
                  withSubtext={<Skeleton.Text size="small" width={200} />}
                />
              </Box>
            </div>
          );
        })}
      </div>
    </>
  );
};
